import http from './http'

class Auth {
  login (email, password) {
    return http.post('/user_token', { auth: { email, password } })
  }

  redirectLogin (token) {
    return http.post('/auths/redirects/verify', {
      auth_redirect_access_verify: { redirect_token: token }
    })
  }

  resetEmail (email) {
    return http.post('/passwords', { email })
  }

  validate (payload) {
    return http.get(`/passwords/${payload}`)
  }

  changePassword (payload) {
    return http.put(`/passwords/${payload.token}`, { ...payload.user })
  }

  acceptTerms () {
    return http.post(`user_term_agreement`)
  }
}

export default new Auth()



// WEBPACK FOOTER //
// ./src/services/auth.js